<template>
	<div>
		<Subpage/>
	    <div class="page-content container">
	        <main>        
				<h1 class="page-title">Skontaktuj się z nami!</h1>        
			<div class="breadcrumbs-area">
				<nav aria-label="breadcrumb"><ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
					<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
					<router-link itemprop="item" to="/">
						<span itemprop="name">Strona gł&oacute;wna</span>
					</router-link>
						<span class="separator">/</span>
					</li>
					<li class="active">Skontaktuj się z nami!</li></ol>
				</nav>
			</div>         
	    	<p><strong>Kontur.IT Sp. z o.o</strong><br />
			ul. Szenwalda 12<br />
			44-113 Gliwice</p>
			<p>email: <a href="mailto: biuro@kontur.it">biuro@kontur.it</a><br />
			tel.:&nbsp;<a href="tel:+48322790616">32 279-06-16</a></p>
	        </main>
	    </div>
	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'About',
  components: {
    Subpage
  }
}
</script>
